import { queryKeys } from "@/lib/queryKeys";
import { useUserPhotos } from "@cs_teamwaydev/mailvista-sdk_react";
import { useQuery } from "@tanstack/react-query";

const useGetUserAvatar = (email: string) => {
    const { getUserPhotoByEmail } = useUserPhotos();

    const getUserAvatar = async () => {
        try {
            const photoUrl = await getUserPhotoByEmail(email);

            const response = await fetch(photoUrl);
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);

            return objectUrl;
        } catch (error) {
            console.error("Error fetching user avatar:", error);

            return null;
        }
    };

    const userAvatar = useQuery({
        queryKey: queryKeys.user.avatar(email),
        queryFn: getUserAvatar,
        enabled: Boolean(email),
    });

    return userAvatar;
};

export default useGetUserAvatar;
